import { curry, unfold } from 'ramda';

export const rangeStep = curry((start, end, step) =>
  unfold(n => ((step > 0 && n < end) || (step < 0 && n > end) ? [n, n + step] : false), start)
);
